import { gql } from '@apollo/client'

const GET_JOB_STATS = gql`
  query GetJobStats($hoursBack: Int) {
    jobStats(hoursBack: $hoursBack) {
      jobStats {
        jobName
        total
        pending
        running
        completed
        failed
        successRate
      }
    }
  }
`

export default GET_JOB_STATS
